"use client";

import { ErrorPageContent } from "@features/shared/error-page-content";

export default function Error() {
  return (
    <div
      className={
        "flex h-svh w-full flex-col items-center justify-center gap-16 lg:flex-row"
      }
    >
      <div className="flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-4">
          <h1 className="text-header-h1 text-mono-900">Oops!</h1>

          <span className="text-body-large-regular text-mono-900">
            Something went wrong!
          </span>
        </div>

        <ErrorPageContent />
      </div>
    </div>
  );
}
